import { ClientPortalRoute } from "../../../features/clientPortal/ClientPortalTab";
import { ContactView } from "../../../features/contacts/pages/contact/ContactView";
import { ContactBilling } from "../../../features/contacts/pages/contact/pages/contact-billing/ContactBilling";
import { ContactEmails } from "../../../features/contacts/pages/contact/pages/contact-emails/ContactEmails";
import { ContactNotes } from "../../../features/contacts/pages/contact/pages/contact-notes/ContactNotes";
import { ContactProfile } from "../../../features/contacts/pages/contact/pages/contact-profile/ContactProfile";
import { ContactTime } from "../../../features/contacts/pages/contact/pages/contact-time/ContactTime";
import { ContactWorks } from "../../../features/contacts/pages/contact/pages/contact-works/ContactWorks";
import { ClientFilesRoute } from "../../../features/files/ClientFilesRoute";
import { PagesEnum } from "./types";

export enum ContactPagesEnum {
  Profile = "profile",
  Works = "works",
  Time = "time",
  Notes = "notes",
  Files = "files",
  Billing = "billing",
  Emails = "emails",
  Portal = "portal",
}

export const ContactPages = {
  path: PagesEnum.Contact,
  label: "Contact",
  params: "customerId",
  component: ContactView,
  children: {
    profile: {
      path: ContactPagesEnum.Profile,
      label: "Profile",
      component: ContactProfile,
    },
    works: {
      path: ContactPagesEnum.Works,
      label: "Work",
      component: ContactWorks,
    },
    time: {
      path: ContactPagesEnum.Time,
      label: "Time",
      component: ContactTime,
    },
    files: {
      path: ContactPagesEnum.Files,
      label: "Files",
      component: ClientFilesRoute,
    },
    notes: {
      path: ContactPagesEnum.Notes,
      label: "Notes",
      component: ContactNotes,
    },
    billing: {
      path: ContactPagesEnum.Billing,
      label: "Billing",
      component: ContactBilling,
    },
    emails: {
      path: ContactPagesEnum.Emails,
      label: "Email",
      component: ContactEmails,
    },
    // Roadmap 1880: the Client portal has its own tab (was a profile widget).
    portal: {
      path: ContactPagesEnum.Portal,
      label: "Client portal",
      component: ClientPortalRoute,
    },
  },
};
